export default "__VITE_ASSET__Kq7eOmua__"